<script>
  export let company;
</script>

<div class="px-8 md:w-2/3 md:mx-auto lg:px-0 lg:w-full">
  <p class="text-12 text-center my-10 lg:text-left">
    This calculator is meant to be for demonstration purposes only. Please
    contact {company} to discuss your home financing goals.
  </p>
</div>



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/CalculatorDisclaimer.svelte